import React, { useEffect, useState } from 'react';
import { Layout, Select, Row, Col, Card, Modal, Button, Popconfirm, Table, Input, notification, Form, DatePicker } from 'antd';
import {
    DeleteOutlined,
    CheckCircleOutlined,
    InfoCircleOutlined,
    CloseCircleOutlined,
    EditOutlined,
    PlusCircleOutlined
} from '@ant-design/icons';
import 'antd/dist/antd.css';
import { update, getall, remove, getbyid, create, getdatawhere } from '../api/api';
import { Typography } from 'antd';
import { Link, browserHistory } from 'react-router';
import { isLogin } from '../reducer/LocalStoradge'
import styled from 'styled-components';
import moment from 'moment';
moment.locale('id')


const { Header, Sider, Content } = Layout;
const { Title } = Typography;
const { TextArea } = Input;
const { Option } = Select;

const InputBoxAbove = styled.div`
    border: 1px solid #a5b1c2;
    margin-top: 20px;
    padding: 10px;
    border-radius: 5px 5px 0px 0px ;
`;
const InputBoxCenter = styled.div`
    border-left: 1px solid #a5b1c2;
    border-right: 1px solid #a5b1c2;
    border-bottom: 1px solid #a5b1c2;
    padding: 10px;
`;

const InputBoxBottom = styled.div`
    border-bottom: 1px solid #a5b1c2;
    border-left: 1px solid #a5b1c2;
    border-right: 1px solid #a5b1c2;
    padding: 10px;
    border-radius: 0px 0px 5px 5px;
`;

const Judul = styled.input`
    width: 100%;
    border: 0px;
    font-family: 'Montserrat', sans-serif;
    margin-top: 20px;
    &:focus{
        outline: none;
    }
`;

const Label = styled.p`
    margin-bottom: 2px;
    font-weight: bold;
    font-size: 14px;
    font-family: 'Montserrat', sans-serif;
`;

const Buttonx = styled.button`
    margin-top: 20px;
    background-color:#4b7bec;
    border: 1px solid #4b7bec;
    border-radius: 5px;
    color: white;
    padding: 7px;
    float: right;
    cursor: pointer;
    font-weight: bold;
    width: 100%;
    &:hover{
        color: #3498db;
        border: 1px solid #3498db;
        font-weight: bold;
    }
`;

const Inputx = styled.input`
    width: 100%;
    border: 0px;
    font-family: 'Montserrat', sans-serif;
    &:focus{
        outline: none;
    }
`;

function Icd() {

    const [modal, setModal] = useState(false)
    const [modalicd, setModalIcd] = useState(false)
    const [id, setId] = useState('')
    const [icd, setIcd] = useState('')
    const [nama_penyakit, setNamaPenyakit] = useState('')
    const [isUpdate, setIsUpdate] = useState('')

    const [icdlist, setIcdlist] = useState([])


    useEffect(() => {
        getIcd()
    }, []);

    const modelTrigger = () => {
        setModal(!modal)
    }

    const getIcd = async () => {
        const data = []
        const _listicd = await getall({ table: 'table_icd' })

        console.log(_listicd)

        let data_length = _listicd.length

        for (let i = 0; i < data_length; i++) {
            data.push({
                nomor: i + 1,
                id: _listicd[i].id,
                icd: _listicd[i].icd,
                nama_penyakit: _listicd[i].nama_penyakit,
            })
        }
        setIcdlist(data)

    }

    const geticdById = async (id) => {
        setId(id)
        console.log(id)
        const datas = {
            table: 'table_icd',
            url: 'getallbyid',
            payload: {
                id,
            }
        }

        const _icd = await getdatawhere(datas)
        console.log(_icd[0])
        setIcd(_icd[0].icd);
        setNamaPenyakit(_icd[0].nama_penyakit);
        setIsUpdate(true)
        console.log(setIsUpdate)
        modelTrigger()
    }



    const createicd = async () => {

        const datas = {
            table: 'table_icd',
            url: 'create',
            payload: {
                icd,
                nama_penyakit,
            }
        }

        const _create = await create(datas)

        if (_create === 1) {
            notification.open({
                message: 'Data Berhasil disimpan',
                description:
                    '',
                icon: <CheckCircleOutlined style={{ color: '#00b894' }} />,
            });
            getIcd()
            // modelTrigger()
            // resetForm()
            resetFormIcd()
        } else {
            notification.open({
                message: 'Gagal Menyimpan Data',
                description:
                    '',
                icon: <CloseCircleOutlined style={{ color: '#e84118' }} />,
            });
        }
    }

    const updateicd = async () => {

        const datas = {
            table: 'table_icd',
            url: 'update',
            id: id,
            payload: {
                icd,
                nama_penyakit,
            }
        }

        let _update = await update(datas)
        if (_update === 1) {
            notification.open({
                message: 'Data Berhasil disimpan',
                description:
                    '',
                icon: <CheckCircleOutlined style={{ color: '#00b894' }} />,
            });
            getIcd()
            modelTrigger()
            // resetForm()
        } else {
            notification.open({
                message: 'Gagal Menyimpan Data',
                description:
                    '',
                icon: <CloseCircleOutlined style={{ color: '#e84118' }} />,
            });
        }
    }

    const removeicd = async (id) => {

        const datas = {
            table: 'table_icd',
            url: 'remove',
            payload: {
                id,
            }
        }
        const hapus = await remove(datas)
        console.log(hapus)
        if (hapus === 1) {
            notification.open({
                message: 'Data Berhasil dihapus',
                description:
                    '',
                icon: <CheckCircleOutlined style={{ color: '#00b894' }} />,
            });
            //getRiwayat(rm)
            resetFormIcd()
        }
    }

    const resetFormIcd = () => {
        setIcd('')
        setNamaPenyakit('')
    }

    const createnew = async () => {
        modelTrigger()
        setIsUpdate(false)
        resetFormIcd()
    }

    const createorupdate = () => {
        isUpdate ? updateicd() : createicd()
    }

    const columns = [
        {
            title: 'No',
            key: 'no',
            dataIndex: 'nomor'
        },
        {
            title: 'Kode ICD',
            key: 'icd',
            dataIndex: 'icd'
        },
        {
            title: 'Nama Penyakit',
            key: 'nama_penyakit',
            dataIndex: 'nama_penyakit'
        },
        {
            title: 'Action',
            key: 'action',
            render: (text, record) => (
                <span>
                    <Button key="edit" onClick={() => geticdById(record.id)} style={{ marginLeft: 10 }} type="primary" icon={<EditOutlined />} >Edit</Button>
                    <Popconfirm
                        title="Anda yakin menghapus Data ini?"
                        //onConfirm={() => removepasien(record.id)}
                        // onCancel={cancel}
                        okText="Yes"
                        cancelText="No"
                    >
                        <Button key="hapus" style={{ marginLeft: 10 }} type="danger" icon={<DeleteOutlined />} >Hapus</Button>
                    </Popconfirm>
                </span>
            ),
        },
    ];

    return (
        <Content
            className="site-layout-background"
            style={{
                margin: '24px 16px',
                padding: 24,
                minHeight: '100%',
            }}
        >

            <Card
                title="Master Data ICD"
                extra={<Button type="dashed" onClick={createnew}>Tambah ICD </Button>}
                style={{ width: '100%', borderWidth: 0 }}
                headStyle={{ color: 'white', backgroundColor: '#0984e3', fontWeight: 'bold', fontSize: 20 }}
            />

            <Table columns={columns} dataSource={icdlist} />

            <Modal
                title="Data ICD"
                centered
                visible={modal}
                onOk={createorupdate}
                onCancel={modelTrigger}
                width={1000}
            >
                <Row>
                    <Col xs={24} sm={24} md={12} lg={12} xl={12} style={{ paddingLeft: 5, paddingRight: 5, marginBottom: 15 }}>
                        <Label>Kode Icd</Label>
                        <Input value={icd} style={{ width: '100%' }} onChange={({ target }) => setIcd(target.value)} placeholder="Kode ICD" />
                    </Col>
                    <Col xs={24} sm={24} md={12} lg={12} xl={12} style={{ paddingLeft: 5, paddingRight: 5, marginBottom: 15 }}>
                        <Label>Nama Penyakit</Label>
                        <Input value={nama_penyakit} style={{ width: '100%' }} onChange={({ target }) => setNamaPenyakit(target.value)} placeholder="Nama Penyakit" />

                    </Col>
                </Row>
            </Modal>


        </Content>
    )
}

export default Icd;



